export const NewPersianUsersTemplate = {
    name: 'new_persian_users',
    label: 'Verify for additional Ramps',
    subject: 'نحوه ارسال وجه به ایران',
    category: 'compulsory',
    body: "<div style='direction: rtl; font-family: tahoma' class='persian-text'>"
        + "<p>با درود،</p>"
        + "<p>از اینکه به جمع کاربران ربیت پیوسته‌اید خوشحالیم.</p>"
        + "<p>چنانچه <b>مایل به ارسال وجه به ایران</b> هستید، لطفا این مراحل را طی کنید:</p>"
        + "<ol>"
        + "<li>به بخش verification بروید: https://my.rebit.co.nz/account/verification"
        + "<ol type='a'>"
        + "<li>ایمیل خود را تایید کنید.</li>"
        + "<li>کارت شناسایی و هویت خود را تایید کنید.</li>"
        + "</ol>"
        + "</li>"
        + "<li>در این مرحله ما دسترسی به کشور ایران را برای شما فعال می‌کنیم.</li>"
        + "<li>پس از لاگین مجدد شما نرخ لحظه‌ای ارسال وجه به ایران را مشاهده خواهید کرد و قادر خواهید بود در چند قدم ساده ثبت سفارش انجام دهید.</li>"
        + "</ol>"
        + "<p>نرخ های ما معمولا نزدیک به نرخهای میانگین بازار و یا بهتر از میانگین هستند. چنانچه پیش از طی مراحل بالا تمایل به آگاهی از نرخ تبادل یا هر پرسش دیگری دارید، از طریق گزینه چت گوشه سایت با ما تماس بگیرید.</p>"
        + "<p>با سپاس<br/><b>Rebit Money Transfer</b></p>"
        + "</div>"
}

